"use client"
/**
 * Crisp in-app support chat widget (L2).
 *
 * Setup:
 *   1. Create a free account at https://crisp.chat
 *   2. Get your Website ID from Settings → Website → Integration
 *   3. Add env var: NEXT_PUBLIC_CRISP_WEBSITE_ID=<your-id>
 *
 * The widget renders only when NEXT_PUBLIC_CRISP_WEBSITE_ID is set,
 * so it is safe to deploy without it configured.
 */
import Script from "next/script"

export default function SupportChat() {
  const crispId = process.env.NEXT_PUBLIC_CRISP_WEBSITE_ID
  if (!crispId) return null

  return (
    <Script id="crisp-chat" strategy="lazyOnload">{`
      window.$crisp = [];
      window.CRISP_WEBSITE_ID = "${crispId}";
      (function(){
        var d = document;
        var s = d.createElement("script");
        s.src = "https://client.crisp.chat/l.js";
        s.async = 1;
        d.getElementsByTagName("head")[0].appendChild(s);
      })();
    `}</Script>
  )
}
